const toNumber = <T = number | undefined>(input: unknown, defaultValue: T): T => {
  if (typeof input === 'number') {
    return input as unknown as T
  }
  if (input === '') {
    return defaultValue
  }
  if (typeof input === 'string' || typeof input === 'boolean') {
    const parsed = Number(input)
    if (!isNaN(parsed)) {
      return parsed as unknown as T
    }
  }
  return defaultValue
}

export default toNumber
